import { MenuItem, Select } from '@mui/material';
import { graphql } from '../../gql';
import { useApiQuery } from '../../query/hooks';
import { ComponentProps, FC } from 'react';
import { LoadableSelect } from '../../form/LoadableSelect';
import { FormattedMessage } from 'react-intl';

const listMetricDataSource = graphql(`
	query connections_listMetricDataSource {
		listMetricSource {
			id
			name
		}
	}
`);

const MetricSourceSelect: FC<ComponentProps<typeof Select<string>> & Readonly<{ defaultSourceName?: string }>> = ({
	value,
	defaultSourceName,
	...props
}) => {
	const { isLoading, data } = useApiQuery(listMetricDataSource);

	return (
		<LoadableSelect
			{...props}
			loading={isLoading}
			value={value ?? '' /* value cannot be undefined in order to keep the input controlled */}
		>
			{data?.listMetricSource
				.filter((source) => {
					if (defaultSourceName !== 'Manual' && source.name === 'Manual') {
						return null;
					}
					return source;
				})
				.map((metricSource) => (
					<MenuItem key={metricSource.id} value={metricSource.id}>
						{metricSource.name === 'Manual' ? <FormattedMessage id={'resources.metrics.table.value.manually'} /> : metricSource.name}
					</MenuItem>
				))}
		</LoadableSelect>
	);
};

export { MetricSourceSelect };
